import { render, staticRenderFns } from "./PaymentConfig.vue?vue&type=template&id=654781aa&scoped=true"
import script from "./PaymentConfig.vue?vue&type=script&lang=js"
export * from "./PaymentConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654781aa",
  null
  
)

export default component.exports